import React, { PropsWithChildren, useRef } from "react";
import { EventEmitter } from "events";
import { EventContext } from "./EventContext";
import { useHideUnimportantErrors } from "../../useHideUnimportantErrors";

export function EventContextProvider(props: PropsWithChildren<unknown>) {
    // Hide dev env resizeObserver errors. It has nothing to do with the eventContext, but this is a high level, always loaded function component that can use hooks.
    useHideUnimportantErrors();

    const eventEmitter = useRef<EventEmitter>();

    if (!eventEmitter.current) {
        eventEmitter.current = new EventEmitter();
    }

    return (
        <EventContext.Provider value={eventEmitter.current}>
            {props.children}
        </EventContext.Provider>
    );
}
